import React from 'react'
import { Link } from 'react-router-dom'
import { showcaseProfilePath } from '../../showcase/display'
import { GutstringBrand } from '../GutstringBrand'

interface ShowcaseShellProps {
  artistLabel: string
  profileUsername?: string
  children: React.ReactNode
}

/** Page chrome matching the original static ShowcasePage. */
export function ShowcaseShell({
  artistLabel,
  profileUsername,
  children,
}: ShowcaseShellProps) {
  return (
    <div className="min-h-screen bg-white text-black select-none pb-28">
      <header className="fixed top-0 left-0 right-0 z-50 flex justify-start px-5 md:px-8 py-4 md:py-5 bg-white/90 backdrop-blur-sm">
        <GutstringBrand variant="dark" linkToHome />
      </header>

      <main className="mx-auto max-w-3xl px-5 md:px-8 pt-24 md:pt-28 pb-16">
        <div className="mb-8 md:mb-10">
          <p className="font-semibold tracking-wide uppercase cursor-default">
            {artistLabel}
          </p>
          {profileUsername && (
            <Link
              to={showcaseProfilePath(profileUsername)}
              className="mt-2 inline-block font-mono text-[10px] uppercase tracking-widest text-black/40 hover:text-black/70 transition-colors"
            >
              View profile
            </Link>
          )}
        </div>
        {children}
      </main>
    </div>
  )
}
